
angular.module('mtic.components.navbar')
.directive('navBarHelp', function (EventManager, language, $log, BRANDING, $rootScope) {
  return {
    templateUrl: 'template.html',
    restrict: 'E',
    scope: {},
    link: function (scope, element, attrs) {
      var eventManager = new EventManager('navBarHelp', scope)
      // eventManager.broadcast('navigation:' + type + ':change', this[type + 'On']);

      var isOlarkVisible = false;

      //use this if you need to set olark language dynamically
      // eventManager.listen('language:change', function(){     
      //   if(language.getCurrentSelectedLanguage() === 'en'){
      //     window.olark('api.box.setLocale', 'en-US')
      //   }else{
      //     window.olark('api.box.setLocale', 'fr-FR')
      //   }
      // })

      scope.openHelpChat = function(forced){
        if (isOlarkVisible && !forced){
          isOlarkVisible = false;
          window.olark('api.box.hide');
          eventManager.broadcast("user:chat", "close");
        }
        else{
          isOlarkVisible = true;
          window.olark('api.box.expand');

          eventManager.broadcast("user:chat", "open");
        }
      }

      eventManager.listen('help:open:forced', function(){
        scope.openHelpChat(true);
      });

    }
  }
})
